<template>
  <div>
    <ots-main-title></ots-main-title>

    <el-tabs v-model="requestForm.typeId">
      <el-tab-pane label="按照分数试算合格分数线" name="1"></el-tab-pane>
      <el-tab-pane label="按照合格率试算合格分数线" name="2"></el-tab-pane>
    </el-tabs>

    <ots-refer v-bind='$attrs' v-on='$listeners' :selectList="selectList" :requestForm='requestForm'></ots-refer>

    <div class="inputList" v-if="requestForm.courseId">
      <div class="Number_Of_Examinees title">应考人数：<span style="color: #909399;">{{shouldCount}}</span></div>
      <div class="Number_Of_Examinees title">实考人数：<span style="color: #67c23a;">{{examCount}}</span></div>
    </div>

    <div class="inputList">
        <div class="title">{{requestForm.typeId == '1' ? '合格分数线设置': '合格率设置'}}</div>
        <div class="ipScope">
          <div v-for="(item, index) in LineList" :key="index" class="inputBox">
            <el-input v-model="item.score" placeholder="大于等于"></el-input>
            <span>{{requestForm.typeId == '1' ? '分' : '%'}}</span>
            <i v-if="index !== 0" class="el-icon-delete" @click="deletScore(index)"></i>
          </div>
          <div class="buttons">
            <el-button type="primary" round @click="addScore">+ 增加</el-button>
            <el-button type="primary" round plain style="margin-left: 36px;" @click="qualified_Personnel(1)">{{requestForm.typeId == '1' ? '按照实考人数试算合格人数占比': '按照实考人数试算合格分数线'}}</el-button>
            <el-button type="primary" round plain style="margin-left: 36px;" @click="qualified_Personnel(2)">{{requestForm.typeId == '1' ? '按照应考人数试算合格人数占比': '按照应考人数试算合格分数线'}}</el-button>
          </div>
        </div>
    </div>

    <div class="mainCon">
      <div class="ots-table" style="position: relative;">
        <el-table ref="el-table" :data="tableData" style="width: 100%;" @cell-mouse-enter="mouseEnter" :cell-style="cellStyle" @cell-mouse-leave="mouseLeave">
          <template v-for="(item, index) in tableHeader">
            <el-table-column :key="index" :label="item.title" v-bind="setAttribute(item, index)">
              <template slot-scope="scope">
                <span class="table-text" v-html="getTableText(item, scope)" @click="getTableText(item, scope)"></span>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <p class="msg" v-show="isShowMsg" id="msg" @mouseleave="mouseLeave">{{msg}}</p>
      </div>
    </div>





  </div>
</template>
<script>
import { getTrialScoreLinePlanListApi, getCourseListApi, getTrialScoreLineListApi, getExamNumByCourseAPI } from "@/http/modules/examSet/score";
export default {
  name: 'ots-refer-search',
  data () {
    return {
      activeName: 'second',

      selectList: [
        {
          title: "批次名称",
          type: "select",
          requestKey: "planId",
          label: "planName",
          value: "planId",
          data: [],
        },
        {
          title:'课程名称',
          type: "select",
          requestKey:'courseId',
          label: "courseName",
          value: "courseId",
          data: [],
        }
      ],
      requestForm: {
        planId: '',
        courseId: '',
        typeId: '1',
        flag: '',
      },
      LineList: [
        { score: 0 },
      ],
      tableHeader: [
        {
          title: "分数线",
          prop: "passScore",
        },
        {
          title: "合格人数",
          prop: "passCount",
        },
        {
          title: "不合格人数",
          prop: "failCount",
        },
        {
          title: "合格人数占比",
          prop: "passPercent",
          formatter: (scope) => {
            return scope.row.passPercent + "%";
          }
        }
      ],
      tableData: [],
      shouldCount: '',
      examCount: '',
      msg: '',
      isShowMsg: false,
    }
  },

  watch: {
    "requestForm.planId": "getCourseList",
    "requestForm.typeId": "resetAllData",
    "requestForm.courseId": "getExamNumber",
  },

  computed: {
   useQualified_Personnel() {
     const Reg = /^\d+(\.\d{1,2})?$/;
     return Object.values(this.LineList).every(
      (line) => line.score === "" || Reg.test(Number(line.score))
     );
   }
  },

  mounted() {
    this.getOverPlanList();
  },

  methods: {
    cellStyle(row) {
      if (row.row.msg) {
        return 'color: #f56c6c;'
      }
    },

    mouseEnter(row) {
      if (row.msg) {
        this.msg = row.msg;
        this.isShowMsg = true;
      }
    },
    
    mouseLeave(row) {
      this.msg = '';
      this.isShowMsg = false;
    },

    resetAllData(typeId) {
      this.tableData = [];
      this.LineList = [{ score: 0 }];
      let item_1, item_2;
      if (typeId == '1') {
        item_1 = {
          title: "分数线",
          prop: "passScore",
        }
        item_2 = {
          title: "合格人数占比",
          prop: "passPercent",
          formatter: (scope) => {
            return scope.row.passPercent + "%";
          }
        }
      } else {
        item_1 = {
          title: "合格率",
          prop: "passPercent",
          formatter: (scope) => {
            return scope.row.passPercent + "%";
          }
        }
        item_2 = {
          title: "合格分数线",
          prop: "passScore",
        }
      }
      this.tableHeader[0] = item_1;
      this.tableHeader[3] = item_2;
    },

    async getExamNumber(courseId) {
      let params = {
        planId: this.requestForm.planId,
        courseId
      }
      const { data } = await getExamNumByCourseAPI(params);
      this.shouldCount = data.shouldCount;
      this.examCount = data.examCount;
    },

    addScore() {
      if (this.LineList.length === 5) {
        this.$message.error("合格线最多允许添加5条！");
      } else {
        let item = { score: "" };
        this.LineList.push(item);
      }
    },

    deletScore(index) {
      this.LineList.splice(index, 1);
    },

    async qualified_Personnel(flag) {
      this.requestForm.flag = flag;
      if (!this.useQualified_Personnel) {
        this.$message.error(`${this.requestForm.typeId == 1 ? '合格分数线': '合格率'}设置有误，请修改后重试！`);
        return;
      }
      if (!this.requestForm.courseId) {
        this.$message.warning("请选择课程！");
        return;
      }
      let passScore = this.LineList.map(e=>{
        return e.score
      }).join(",")
      let param = { ...this.requestForm, passScore }
      const { data: tableData } = await getTrialScoreLineListApi(param);
      this.tableData = tableData;
    },

    async getCourseList(planId) {
      this.requestForm.courseId = '';
      const { data: courseList } = await getCourseListApi({planId});
      this.selectList[1].data = courseList;
    },

    async getOverPlanList() {
      const { data: planList } = await getTrialScoreLinePlanListApi({flag: 1});
      this.selectList[0].data = planList;
      this.requestForm.planId = planList[0].planId;
    },

    setAttribute(item, index) {
      let maxIndex = this.tableHeader.length - 1;
      let headerAlign = "";
      let align
      if (index === 0) {
        headerAlign = "left";
        align = "left";
      } else if (index === maxIndex) {
        headerAlign = "right";
        align = "right";
      } else if (item.type == 'buttons') {
        headerAlign = "right";
        align = "right";
      } else {
        headerAlign = item.headerAlign || "center";
        align = item.align || "center";
      }        
      return {
        headerAlign,
        prop: item.prop,
        fixed: item.fixed,
        label: item.title,
        width: item.width || "auto",
        align
      };
    },
    getTableText(item, scope) {
      let text = item.formatter ? item.formatter(scope) : scope.row[item.prop]
      if (text === "Invalid date") {
        return "-"
      } else {
        return text || text == "0" ? text : "-"
      }
    },
  }
}
</script>
<style scoped lang="less">
/deep/ .el-button.query-btn{
  display: none;
}

.msg {
  width: 100%; 
  height: 48px; 
  background: #fdf6ec;
  color: #f56c6c;
  position: absolute; 
  top: 0px;
  box-sizing: border-box;
  text-align: center;
  line-height: 48px;
  border: 1px solid #f56c6c;
  border-radius: 4px;
  font-family: "PingFangSC-Medium, PingFang SC";
  transition: all .3s;
}

.inputList {
  width: 100%;
  background: #fff;
  border-radius: 8px;
  margin-top: 16px;
  border: 1px solid transparent;
  box-sizing: border-box;
  font-family: "PingFangSC-Medium, PingFang SC";
}
.title {
  font-size: 14px;
  color: #626673;
  font-weight: 500;
  margin-top: 20px;
  padding-left: 24px;
  box-sizing: border-box;
}

.Number_Of_Examinees {
  margin-bottom: 16px;
  display: inline-block;
  margin-right: 16px;
}

.ipScope {
  // margin-top: 16px;
  margin-left: 24px;
  width: 380px;
  padding: 24px 32px;
  box-sizing: border-box;
  border-radius: 8px;
  .buttons {
    display: flex;
    justify-content: left;
    margin-top: 24px;
  }
  h6 {
    color: #45494d;
    font-size: 14px;
    margin-bottom: 16px;
  }
  .inputBox {
    display: flex;
    height: 36px;
    line-height: 36px;
    justify-items: center;
    vertical-align: middle;
    margin-bottom: 8px;
    /deep/ .el-input {
      width: 200px;
      height: 36px;
      line-height: 36px;
    }
    span {
      margin: 0 11px;
      color: #626673;
    }
    i {
      margin: 12px 0 0 20px;
      color: #006aff;
    }
  }
  /deep/ .el-radio-button__inner {
    margin-right: 8px;
    color: #45494d !important;
    background: #f4f5f8 !important;
    font-size: 13px;
    border-radius: 4px !important;
    border: 1px solid #dadde6 !important;
    padding: 10px 20px;
  }
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: #ebf5ff !important;
    border: 1px solid #006aff !important;
    color: #006aff !important;
    box-shadow: none;
  }

  /deep/ .el-checkbox-button__inner {
    margin-right: 8px;
  }

  /deep/ .el-input .el-input__inner {
    width: 200px;
    height: 36px;
    line-height: 18px;
  }

}
</style>